<template>
  <div id="Client">

    <page-hero headerText=message.hero.clientHeader subText=message.hero.clientSub></page-hero>

    <!--- Introductory text -->
    <div class="row justify-content-center mb-5 mb-lg-7">
      <div class="col-10 col-sm-6 col-md-4 col-xl-3">
        <h3 class="text-align-left text-nowrap">{{ $t('message.client.together') }}</h3>
        <p>{{ $t('message.client.togetherTxt') }}</p>
      </div>

      <div class="col-10 col-sm-4 col-md-3 col-xl-2 text-center my-auto pt-4 pt-md-0">
        <img class="icon-sm" src="/static/images/astronaut/astronaut.svg" alt="Astronaut image">
        <img class="icon-sm" src="/static/images/astronaut/astronaut.svg" alt="Astronaut image">
      </div>

    </div>

    <hr class="mb-5 mb-lg-7 d-none d-sm-block"/>

    <!-- Cooperation text -->
    <div class="row justify-content-center mb-5 mb-lg-7">
       <div class="col-8 col-sm-4 col-md-3 col-xl-2 pt-5 pt-md-0 text-center my-auto order-2 order-sm-1">
        <p class="light-grey-text quote">{{ $t('message.client.quote') }}</p>
      </div>
      <div class="col-10 col-sm-6 col-md-4 col-xl-3 order-1">
        <h3>{{ $t('message.client.consultant') }}</h3>
          <p>{{ $t('message.client.consultantTxt1') }}</p>
      </div>
    </div>

    <!-- Blue background section-->
    <div class="slanted-container-left"></div>

    <div class="row justify-content-center blue-background pt-5 pb-5 pt-lg-7 pb-lg-7">

      <div class="col-10 col-sm-5 col-md-4 col-xl-3">
        <h3 class="font-weight-light text-align-left">{{ $t('message.client.work') }}</h3>
        <p>{{ $t('message.client.workTxt1') }}</p>
        <p>{{ $t('message.client.workTxt2') }}</p>
      </div>
      <div class="col-10 col-sm-5 col-md-3 col-xl-2 my-auto d-none d-sm-block">
        <ul class="list-group">
          <li class="list-group-item">{{ $t('message.client.technique1') }}</li>
          <li class="list-group-item">{{ $t('message.client.technique2') }}</li>
          <li class="list-group-item">{{ $t('message.client.technique3') }}</li>
          <li class="list-group-item">{{ $t('message.client.technique4') }}</li>
          <li class="list-group-item">{{ $t('message.client.technique5') }}</li>
          <li class="list-group-item">{{ $t('message.client.technique6') }}</li>
          <li class="list-group-item">{{ $t('message.client.technique7') }}</li>
          <li class="list-group-item">{{ $t('message.client.technique8') }}</li>
          <li class="list-group-item">{{ $t('message.client.technique9') }}</li>
          <li class="list-group-item">{{ $t('message.client.technique10') }}</li>
          <li class="list-group-item">{{ $t('message.client.technique11') }}</li>
          <li class="list-group-item">{{ $t('message.client.technique12') }}</li>
          <li class="list-group-item">{{ $t('message.client.technique13') }}</li>
        </ul>
      </div>
    </div>

    <div class="slanted-container-right mb-5 mb-lg-7"></div>

    <!-- Contact us section -->
    <div class="row justify-content-center mb-5 mb-lg-7">
      <div class="col-10 col-sm-10 col-md-4 text-center">
        <h3>{{ $t('message.client.contactUs') }}</h3>
      </div>
      <div class="w-100"></div>
      <div class="col-9 col-sm-7 col-md-4 col-xl-3 text-center">
        <p>{{ $t('message.client.contactUsTxt') }}</p>
        <div class="cta-button-container mx-auto">
          <router-link to="Contact">
            <div class="cta-button">{{ $t('message.button.contact') }}</div>
          </router-link>
        </div>
      </div>

    </div>

    <!-- Parallax photo -->

    <div class="slanted-container-in-right"></div>

    <div class="row photo-section"></div>

  <page-footer></page-footer>

  </div>
</template>

<script>
import PageHero from '@/components/shared/PageHero';
import PageFooter from '../shared/PageFooter';

export default {
  name: 'Client',
  components: {
    PageFooter,
    PageHero,
  },
  methods: {
    // eslint-disable-next-line
    scroll_first_section: function () {
      window.scroll({ top: 650, left: 0, behavior: 'smooth' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/_variables.scss';
@import '../../assets/styles/_shared.scss';
@import '../../assets/styles/_slanted.scss';

.quote {
  font-size: 1.3em;
  text-align: center;
  //color: $headline-text;
}

.blue-background {
  background-color: $dark-blue;
  p, h3, li {
    color: $white-text;
  }
  li {
    border: 0;
    padding-top: 0;
    padding-bottom: 0;
    background-color: $dark-blue;
    font-size: 18px;
  }
  ul {
    border-left: 2px solid #d0d0d0;
    margin-left: 50px;
  }
}

.icon-sm {
  width: 100px;
  @media screen and (max-width: 995px) {
    width: 85px;    //so that the astronauts dont stack on top of each other on some screen sixes
 }
}

.slanted-container-left {
  @include slanted-container-left(white, $dark-blue, 0);
}

.slanted-container-right {
  @include slanted-container-right(white, $dark-blue, 0);
}

.slanted-container-in-right {
  @include slanted-container-right(rgba(white, 0), white, -120px);
  margin-top: -120px;
}

.photo-section {
  @include footer-banner('/static/images/Uppsala_domkyrka.jpg');
}

</style>
